import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchQuranData } from "../actions/QuranActions";
import './quran.css';

function Quran() {
    const dispatch = useDispatch();
    const { quran, loading, error } = useSelector((state) => state.QuranState);
    const [searchText, setSearchText] = useState(""); // حالة لنص البحث

    useEffect(() => {
        dispatch(fetchQuranData());
    }, [dispatch]);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    const convertToArabicNumbers = (number) => {
        return number
            .toString()
            .replace(/\d/g, (digit) => "٠١٢٣٤٥٦٧٨٩"[digit]);
    };

    // دالة لإزالة التشكيل
    const removeDiacritics = (text) => {
        return text.replace(/[\u064B-\u0652]/g, ''); // إزالة الحركات من النص العربي
    };

    // إذا كانت البيانات غير متوفرة، استخدم مصفوفة فارغة كقيمة افتراضية
    const filteredQuran = searchText
        ? (quran || []).filter((q) =>
            removeDiacritics(q.name).includes(removeDiacritics(searchText))
        )
        : quran || []; // استخدم مصفوفة فارغة كقيمة افتراضية

    return (
        <div className="quran">
            <h2 style={{ textAlign: "center", fontFamily: "sans-serif", fontWeight: "bold" }}>
                القرآن الكريم كامل
            </h2>
            <input
                style={{
                    width: "94%",
                    textAlign: "center",
                    margin: "auto",
                    fontWeight: "bold",
                    // marginBottom: "10px",
                    marginTop:"10px",
                    fontFamily: "sans-serif"
                }}
                type="text"
                className="form-control"
                placeholder="ادخل اسم السورة التي تريدها"
                aria-label="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
            />
            <div className="quransdisplay">
                {filteredQuran.length > 0 ? (
                    filteredQuran.map((q) => (
                        <div
                            key={q.number}
                            onClick={() => {
                                window.location.href = `/quran/${q.number}`;
                            }}
                            className="soura"
                        >
                            <p>{convertToArabicNumbers(q.numberOfAyahs)} آيات</p>
                            <h5>{q.name}</h5>
                            <div className="numberofsoura">{convertToArabicNumbers(q.number)}</div>
                        </div>
                    ))
                ) : (
                    <p>لم يتم العثور على نتائج</p>
                )}
            </div>
        </div>
    );
}

export default Quran;
